import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { LecturesSideBarFilterDatamodel } from '../side-bar/lectures-side-bar-filter-datamodel';
import { ReportBranchType } from '../../../api/types/reports/report-branch.type';
import { ReportProgram } from '../../../api/types/reports/report-abstract-program.type';
import { ReportCourseType } from '../../../api/types/reports/report-abstract-course.type';
import {
  LectureStatus,
  LectureStatusType,
} from '../../../api/types/programs/course/lectures/lecture-status.type';
import { ReportUserType } from '../../../api/types/reports/report-user.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export interface ReportClassType {
  classId: number;
  className: string;
}

interface LecturerWorkingHours extends ReportUserType {
  workingStartTime: Date;
  workingEndTime: Date;
}

export interface LecturesResType
  extends ReportBranchType,
    ReportProgram,
    ReportCourseType,
    ReportClassType {
  lecturers: LecturerWorkingHours[];
  startTime: Date;
  endTime: Date;
  lectureStatus: LectureStatus;
  studentNumberInCourse: number;
  studentAttendance: number;
  lectureSubject: string;
}

export const getLecturesDataOperation = async (
  filters: LecturesSideBarFilterDatamodel,
  setLoading: (loading: boolean) => void,
  setData: (data: LecturesResType[]) => any,
) => {
  try {
    setLoading(true);

    const res = await appApi.getLectures(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    setData(res.data.body);

    setLoading(false);
  } catch (error) {
    console.error(
      `getLecturesDataOperation is failed with the filterData: ${JSON.stringify(filters)} and the error: ${error}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    throw error;
  }
};
